import _regenerator from "/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import store from '@/store';
import { COPY_SPEACH } from '@/store/actions/speach';
import { CopySpeachStatus } from '@/store/enums/speachEnum';
import SpeachResultTable from '@/components/platform/copySpeach/SpeachResultTable.vue';
import Banner from '@/components/banner/Banner.vue';
var ResultCopySpeach = /*#__PURE__*/function (_Vue) {
  function ResultCopySpeach() {
    var _this;
    _classCallCheck(this, ResultCopySpeach);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ResultCopySpeach, [].concat(args));
    _defineProperty(_this, "loading", true);
    _defineProperty(_this, "speachCopied", 0);
    return _this;
  }
  _inherits(ResultCopySpeach, _Vue);
  return _createClass(ResultCopySpeach, [{
    key: "mounted",
    value: function mounted() {
      this.launchCopy();
    }
  }, {
    key: "launchCopy",
    value: function () {
      var _launchCopy = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _iterator, _step, _this$sourcePlatform, _this$destinationPlat, c, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              this.speachCopied = 0;
              _iterator = _createForOfIteratorHelper(this.listSpeachToCopy);
              _context.p = 1;
              _iterator.s();
            case 2:
              if ((_step = _iterator.n()).done) {
                _context.n = 5;
                break;
              }
              c = _step.value;
              _context.n = 3;
              return store.dispatch(COPY_SPEACH, {
                platformSourceID: (_this$sourcePlatform = this.sourcePlatform) === null || _this$sourcePlatform === void 0 ? void 0 : _this$sourcePlatform.platformID,
                platformDestinationID: (_this$destinationPlat = this.destinationPlatform) === null || _this$destinationPlat === void 0 ? void 0 : _this$destinationPlat.platformID,
                courToCopy: c
              });
            case 3:
              this.speachCopied++;
            case 4:
              _context.n = 2;
              break;
            case 5:
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              _iterator.e(_t);
            case 7:
              _context.p = 7;
              _iterator.f();
              return _context.f(7);
            case 8:
              this.loading = false;
              this.$emit('speachesCopied');
            case 9:
              return _context.a(2);
          }
        }, _callee, this, [[1, 6, 7, 8]]);
      }));
      function launchCopy() {
        return _launchCopy.apply(this, arguments);
      }
      return launchCopy;
    }()
  }, {
    key: "listSpeachToCopy",
    get: function get() {
      return store.getters.listSpeachToCopy;
    }
  }, {
    key: "totalSpeachCopiedSuccess",
    get: function get() {
      return this.listSpeachToCopy.filter(function (x) {
        return CopySpeachStatus.SUCCESS === x.copySpeachStatus;
      }).length;
    }
  }, {
    key: "totalSpeachCopiedError",
    get: function get() {
      return this.listSpeachToCopy.filter(function (x) {
        return CopySpeachStatus.ERROR === x.copySpeachStatus;
      }).length;
    }
  }, {
    key: "sourcePlatform",
    get: function get() {
      return store.getters.sourcePlatform;
    }
  }, {
    key: "destinationPlatform",
    get: function get() {
      return store.getters.destinationPlatform;
    }
  }]);
}(Vue);
ResultCopySpeach = __decorate([Options({
  components: {
    SpeachResultTable: SpeachResultTable,
    Banner: Banner
  }
})], ResultCopySpeach);
export default ResultCopySpeach;